import oppRegService from '@/services/oppreg.service.js'
import mngServices from '@/services/mngServices.service.js'
import awsAcctService from '@/services/awsacct.service.js'
export default {
  getManagedServices: (context, params) => {
    context.commit('setLoadingList', true)

    mngServices.getAllManagedServices(params, (res, err) => {
      context.commit('loadList', res.data)
      context.commit('setLoadingList', false)
      context.commit('setNextPageKey', res.next_data)
    })
  },
  searchOpportunityId: async (context, sfdcId) => {
    if (!sfdcId) {
      context.commit('setSearchResponse', { error: true, message: 'Opportunity Id not yet registered. Go to Galaxy “Opportunity Registrations” to reqister.' })
    } else {
      console.log('searchopportunity_id:', sfdcId)
      context.commit('setLoadingWorkloads', true)
      context.commit('setSearchResponse', { error: false, message: '' })
      let opp = await oppRegService.findOpportunityById(sfdcId)

      if (!opp) {
        context.commit('setSearchResponse', { error: true, message: 'Opportunity Id not yet registered. Go to Galaxy “Opportunity Registrations” to reqister.' })
        context.commit('setLoadingWorkloads', false)
      } else {
        context.commit('setWorkloadRecord', { opportunityName: opp.SFDC_Oppty_Name })
        oppRegService.getWorkloadsByOppId(sfdcId, (res, err) => {
          if (err) {
            context.commit('setSearchResponse', { error: true, message: err.message })
          } else {
            console.log('searchOpportunityId', res.workloads)
            context.commit('setWorkloads', res.workloads)
          }
          context.commit('setLoadingWorkloads', false)
        })
      }
    }
  },
  getAccountList: (context) => {
    awsAcctService.getAllCustomers(res => {
      context.commit('awsAccountList', res)
    })
  },
  validateWbsCode: (context, code) => {
    console.log('onWbsValidate 2', code)
    context.commit('resetWbsValidation')
    context.commit('setWbsCodeValidating', true)
    awsAcctService.validateWbsCode(code, (res, err) => {
      if (err) {
        context.commit('setWbsValidationResponse', { valid: false, message: err.message })
      } else {
        context.commit('setWbsValidationResponse', { valid: true, type: res.type, message: res.message })
      }

      context.commit('setWbsCodeValidating', false)
    })
  },
  submitManagedServices: (context, params) => {
    context.commit('setSubmitLoader', true)
    console.log('submitManagedServices', params)
    mngServices.addManagedServices(params, (res, err) => {
      if (err) {
        console.log('addManagedServices err', err)
        context.commit('setSubmitLoader', false)
        context.commit('clearNewManagedServices')
        context.commit('clearManagedServicesList')
      } else {
        console.log('addManagedServices else', res)
        context.commit('setSubmitLoader', false)
        context.commit('clearNewManagedServices')
        context.commit('clearManagedServicesList')
      }
    })
  },
}
